import React from 'react'
import {Modal, Button, Spinner} from 'react-bootstrap'
import {useI18n} from '../../../../../Utils/_helpers/useI18n'

interface PauseInstanceModalProps {
  show: boolean
  onHide: () => void
  onConfirm: () => void
  isPausing: boolean
}

const PauseInstanceModal: React.FC<PauseInstanceModalProps> = ({
  show,
  onHide,
  onConfirm,
  isPausing,
}) => {
  const {t} = useI18n()
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title className='fs-5 text-warning'>
          <i className='bi bi-pause-circle me-2'></i>
          {t('FLOW.LOGS.PAUSE_INSTANCE')}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className='d-flex flex-column gap-3'>
          <div className='d-flex align-items-center gap-2'>
            <i className='bi bi-exclamation-triangle text-warning'></i>
            <span>{t('FLOW.INSTANCE.PAUSE_JOB_SUCCESS')}</span>
          </div>
          <div className='d-flex align-items-center gap-2'>
            <i className='bi bi-pause-circle text-warning'></i>
            <span>{t('FLOW.INSTANCE.PAUSE_JOB_SUCCESS_DESC')}</span>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant='light' onClick={onHide}>
          {t('COMMON.ACTIONS.CANCEL')}
        </Button>
        <Button variant='warning' onClick={onConfirm} disabled={isPausing}>
          {isPausing ? (
            <>
              <Spinner animation='border' size='sm' className='me-2' />
              {t('FLOW.INSTANCE.PAUSE_JOB_SUCCESS')}
            </>
          ) : (
            t('FLOW.LOGS.PAUSE_INSTANCE')
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default PauseInstanceModal
